/** Strategems whose projectile flies from the caster's general portrait (not the hand card). */
export const STRATEGEM_IDS_PROJECTILE_FROM_CASTER_GENERAL = new Set([
  228, // Whispers of Kek
  226, // Embalm
  181, // Tactical Breach
]);

export function usesCasterGeneralProjectileOrigin(strategemIdNum) {
  return Number.isFinite(strategemIdNum) && STRATEGEM_IDS_PROJECTILE_FROM_CASTER_GENERAL.has(strategemIdNum);
}

/**
 * Caster general portrait center in viewport (`player_general` vs `opponent_general` from viewer POV).
 */
export function getStrategemCasterGeneralPixelPosition(
  viewerUserId,
  strategemCasterPlayerId,
  isOpponentStrategem
) {
  if (typeof document === 'undefined') return null;
  let el = null;
  if (
    strategemCasterPlayerId != null &&
    viewerUserId != null &&
    String(strategemCasterPlayerId) !== '' &&
    String(viewerUserId) !== ''
  ) {
    el =
      String(strategemCasterPlayerId) === String(viewerUserId)
        ? document.querySelector('[data-zone="player_general"]')
        : document.querySelector('[data-zone="opponent_general"]');
  } else {
    el = isOpponentStrategem
      ? document.querySelector('[data-zone="opponent_general"]')
      : document.querySelector('[data-zone="player_general"]');
  }
  if (!el) return null;
  const rect = el.getBoundingClientRect();
  return {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
  };
}
